import { Helmet } from "react-helmet-async";
import { Container, Stack, Typography } from "@mui/material";
import WithAuth from "../components/WithAuth";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import APIData from "../components/APIData";
import { useSelector } from "react-redux";
import { bgStyles } from "../utils/cssStyles";

function API() {
  const { emailData, emailStatus } = useSelector((state) => state.email);

  const [APIdataResponse, setAPIdataResponse] = useState("");
  const [flag, setFlag] = useState(false);

  console.log(emailData[1]);

  useEffect(() => {
    if (emailData[1]) {
      axios.get(`/pushfunction/${emailData[1]}`).then((response) => {
        setAPIdataResponse(response.data);
        setFlag(true);
      });
    }
  }, [emailStatus]);
  console.log(emailStatus);
  if (emailStatus === "loading") {
    return <div style={bgStyles}></div>;
  }

  return (
    <Wrapper>
      <Helmet>
        <title> API | Support Tool </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography sx={{ color: "#2065d1" }} variant="h4" gutterBottom>
            Application Programming Interface
          </Typography>
        </Stack>
        <Box>
          {/* <Typography sx={{ marginBottom: "15px" }} variant="h6">
            Kyc
          </Typography> */}
          {flag ? (
            <APIData resData={APIdataResponse} key={emailData[1]} />
          ) : (
            " "
          )}
        </Box>
        <Box>
          {/* <Typography sx={{ marginY: "25px" }} variant="h6">
            Re-Kyc
          </Typography> */}
          {/* <Box className="resDiv">
            <TextField
              id="outlined-summary-flexible"
              label="API"
              multiline
              maxRows={2}
              className="MobInput"
              sx={{ width: "30%" }}
              // value="API"
              // onChange={}
            />
            <TextField
              id="outlined-summary-flexible"
              label="Client Id"
              multiline
              maxRows={2}
              className="MobInput"
              sx={{ width: "30%" }}
              // value={}
              // onChange={}
            />
            <Button sx={{ height: "56px", width: "150px" }} variant="outlined">
              Delete
            </Button>
          </Box> */}
        </Box>
      </Container>
    </Wrapper>
  );
}
export default WithAuth(API);

const Wrapper = styled.div`
  .resDiv {
    display: flex;
    justify-content: space-around;
  }

  @media only screen and (max-width: 768px) {
    .resDiv {
      display: flex;
      justify-content: space-evenly;
      flex-direction: column;
    }
    .resDiv .MobInput,
    button {
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;
